module.exports = __webpack_public_path__ + "images/abartha6ed7338c47f8b27d4ca5a9ddf551995.png";